import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../api';

export function useRememberState(legacyId: string | undefined) {
  return useQuery({
    enabled: Boolean(legacyId),
    queryKey: ['remember', legacyId],
    queryFn: () => api.remember.get(legacyId as string),
    retry: false,
  });
}

export function useToggleRemember(legacyId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (action: 'remember' | 'forget') =>
      action === 'remember' ? api.remember.remember(legacyId) : api.remember.forget(legacyId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['remember', legacyId] });
      qc.invalidateQueries({ queryKey: ['feed'] });
      qc.invalidateQueries({ queryKey: ['random'] });
      qc.invalidateQueries({ queryKey: ['legacy', legacyId] });
    },
  });
}